import { useLocale } from '@va/localization';
import { Paragraph } from '@va/ui/design-system';
import { addNumberSeparator, getPercentageChange, getPercentageColors } from '@va/util/helpers';
import { useMemo } from 'react';

export const ComparisonCell = ({
  currentValue,
  previousValue,
  optionalText,
  options,
}: {
  currentValue: number;
  previousValue: number;
  optionalText?: string;
  options?: Intl.NumberFormatOptions;
}) => {
  const { locale } = useLocale();

  const percentageChange = useMemo(
    () => getPercentageChange(previousValue, currentValue),
    [currentValue, previousValue],
  );
  const colors = getPercentageColors(percentageChange);

  return (
    <div>
      <Paragraph>
        {addNumberSeparator(currentValue, locale, options)} {optionalText}
      </Paragraph>
      <Paragraph colorClassName={colors}>
        {addNumberSeparator(percentageChange, locale, {
          style: 'percent',
          minimumSignificantDigits: 2,
          maximumSignificantDigits: 2,
          signDisplay: 'exceptZero',
        })}
      </Paragraph>
    </div>
  );
};
